<template>
  <section class="wizard">
    <div class="breadcrumbs">
      <ul class="text-small">
        <li
          v-for="step in stepper"
          :key="step.id"
          :class="[{ done: currentStep > step.id }, { active: currentStep === step.id }]"
          @click="currentStep > step.id && !currentStepIsThankYou ? gotoStep(step.id) : null"
        >
          <span>{{ step.name }}</span>
        </li>
      </ul>
    </div>
    <div class="form">
      <Welcome
        v-if="currentStep === 0"
        @navigate="navigate"
      />
      <Profilo
        v-if="currentStep === 1"
        :preset="params.profile"
        :is-complete-profile="completeProfile"
        :profiles="profiles"
        @navigate="navigate"
        @set-profile="setProfile($event)"
        @push-event="pushAnalyticsEvent()"
      />
      <DatiPersonali
        v-if="currentStep === 2"
        :preset="params.personal"
        :profile-id="params.profile.selected.id"
        :is-complete-profile="completeProfile"
        @navigate="navigate"
        @push-event="pushAnalyticsEvent()"
      />
      <DatiAziendali
        v-if="currentStep === 3"
        :preset="params.company"
        :profile-id="params.profile.selected.id"
        :is-complete-profile="completeProfile"
        :is-azienda-estera="aziendaEstera"
        @navigate="navigate"
        @push-event="pushAnalyticsEvent()"
      />
      <Programmi
        v-if="currentStep === 4"
        :preset="params.programs"
        :profile-id="params.profile.selected.id"
        :michelangelo-code="params.company.michelangeloCode"
        :company="params.company"
        @navigate="navigate"
        @push-event="pushAnalyticsEvent()"
      />
      <Credenziali
        v-if="currentStep === 5 && !completeProfile"
        :preset="params.credential"
        @navigate="navigate"
        @push-event="pushAnalyticsEvent()"
      />
      <Privacy
        v-if="currentStep === 6"
        :preset="params.privacy"
        :recap-sitekey="recapSitekey"
        @submit="completeProfile ? submitComplete($event) : submit($event)"
        @navigate="navigate"
        @push-event="pushAnalyticsEvent()"
      />
      <ThankYouPage
        v-if="currentStep === 7"
        :data-params="dataParams"
        :error="error"
        :success-msg="successMsg"
        :complete-profile="completeProfile"
      />
      <div
        v-if="currentStep == 1 && !completeProfile"
        class="login-message"
      >
        <hr>
        <p>
          Hai già un profilo su MySACE?
          <LoginButton
            landing-text="Accedi al tuo profilo"
            class="primary block"
            :params="dataParams"
          />
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import { Paths } from '../../common/paths';
import Welcome from './RegistrazioneWelcome.vue';
import Profilo from './RegistrazioneProfilo.vue';
import DatiPersonali from './RegistrazioneDatiPersonali.vue';
import DatiAziendali from './RegistrazioneDatiAziendali.vue';
import Programmi from './RegistrazioneProgrammi.vue';
import Credenziali from './RegistrazioneCredenziali.vue';
import Privacy from './RegistrazionePrivacy.vue';
import ThankYouPage from './RegistrazioneThankYouPage.vue';
import { GestioneProfili } from '../../common/utenze';
// import { getUrlQueryParam } from '../../util/url/searchParams';
import LoginButton from '../login-button.vue';

import { Analytics } from '../../common/Analytics';

Vue.use(VueLodash, { lodash });

const _ = require('lodash');

export default {
  name: 'WizardRegistrazione',
  components: {
    Welcome,
    Profilo,
    DatiPersonali,
    DatiAziendali,
    Programmi,
    Credenziali,
    Privacy,
    ThankYouPage,
    LoginButton,
  },
  mixins: [Analytics],
  props: {
    recapSitekey: '',
    completeProfile: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: () => {},
    },
    dataParams: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      params: {
        profile: {
          selected: {
            id: null,
          },
        },
        personal: {},
        company: {},
        programs: {
          businessPromotion: false,
          saceEducation: {
            saceEduSigned: false,
          },
        },
        credential: {},
        privacy: {},
      },
      profiles: [],
      currentStep: 1,

      fromPage: 0,
      parameterUrlp: '',
      parameterUrlc: '',
      provenienza: '',
      error: {
        hasError: false,
        msg: null,
        code: '',
      },
      successMsg: '',
    };
  },
  computed: {
    currentStepIsThankYou() {
      return this.currentStep === 7;
    },
    stepper() {
      const privateProfiles = GestioneProfili.PrivatiRegistazione;
      const defaultSteps = [
        {
          id: 0,
          name: 'Completa il tuo profilo',
        },
        {
          id: 1,
          name: 'Chi sei?',
        },
        {
          id: 2,
          name: 'I tuoi dati',
        },
        {
          id: 3,
          name: 'I dati della tua azienda',
        },
        {
          id: 4,
          name: 'I Programmi Sace',
        },
        {
          id: 5,
          name: 'Le tue credenziali',
        },
        {
          id: 6,
          name: 'Privacy e consensi',
        },
      ];
      const excludedSteps = [];
      if (_.includes(privateProfiles, this.params.profile.selected.id)) {
        this.emptyCompany();
        excludedSteps.push(3);
      }
      if (
        !_.includes(GestioneProfili.ProfiliEdu, this.params.profile.selected.id) &&
        !_.includes(GestioneProfili.ProfiliBp, this.params.profile.selected.id)
      ) {
        excludedSteps.push(4);
      }
      if (this.completeProfile) {
        excludedSteps.push(5);
      } else {
        excludedSteps.push(0);
      }
      return defaultSteps.filter(el => !excludedSteps.includes(el.id));
    },
    aziendaEstera() {
      return this.params.profile.selected.id == GestioneProfili.Profili.DIP_AZIENDA_ESTERO;
    },
  },
  watch: {
    'params.profile.selected.id': function () {
      this.setEdu(false);
      this.setBp(false);
      this.parameterUrlp = this.dataParams.p;
      this.parameterUrlc = this.dataParams.c;
      const provenienza = this.parameterUrlp;
      this.provenienza = provenienza;

      // Preflag programmi per tutti i profili
      if (_.includes(GestioneProfili.ProfiliEdu, this.params.profile.selected.id)) {
        this.setEdu(true);
      }
      if (_.includes(GestioneProfili.ProfiliBp, this.params.profile.selected.id)) {
        this.setBp(true);
      }

      switch (provenienza) {
      // case 'calendarioEventi':
      //   if (_.includes(GestioneProfili.ProfiliEdu, this.params.profile.selected.id)) {
      //     this.setEdu(true);
      //   }
      //   if (_.includes(GestioneProfili.ProfiliBp, this.params.profile.selected.id)) {
      //     this.setBp(true);
      //   }
      //   break;
      // case 'businessPromotion':
      //   if (_.includes(GestioneProfili.ProfiliBp, this.params.profile.selected.id)) {
      //     this.setBp(true);
      //   }
      //   break;
      // case 'saceEducation':
      //   if (_.includes(GestioneProfili.ProfiliEdu, this.params.profile.selected.id)) {
      //     this.setEdu(true);
      //   }
      //   break;
      case 'Valutazioneazienda':
        this.provenienza = 'Valutazione Azienda';
        break;
      case 'iniziativa':
        this.parameterUrlc = this.dataParams.prodotto;
        break;
      case 'risk-map':
        this.parameterUrlc = this.dataParams.codIso;
        break;
      case null:
        this.provenienza = 'Registrazione diretta';
        break;
      default:
        this.provenienza = provenienza;
      }
    },
    contact: {
      handler(v) {
        if (this.completeProfile && v.nome && v.cognome) {
          this.params.personal.name = v.nome;
          this.params.personal.surname = v.cognome;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getProfili();
  },
  mounted() {
    if (this.completeProfile) {
      this.currentStep = 0;
    }
    const middle = document.getElementById('middle');
    const fromPage = middle.dataset.frompage;
    this.fromPage = fromPage;

    if (this.provenienza === 'businessPromotion') {
      this.businessPromotion.signedUp = true;
    }
  },
  methods: {
    setEdu(value) {
      this.params.programs.saceEducation.saceEduSigned = value;
    },
    setBp(value) {
      this.params.programs.businessPromotion = value;
    },
    setProfile(profile) {
      this.params.profile = profile;
    },
    emptyCompany() {
      this.params.company = {};
    },
    gotoStep(step) {
      this.currentStep = step;
    },
    navigate(resp) {
      if (resp.navigate === 'logout') {
        window.location.href = '/logout';
        return;
      }
      this.params[resp.step] = resp.params;
      this.currentStep =
        resp.navigate === 'prev' ? (this.currentStep -= 1) : (this.currentStep += 1);
      if (!_.find(this.stepper, ['id', this.currentStep])) {
        this.navigate(resp);
      }
    },
    getProfili() {
      this.showLoading(true);
      const path = this.completeProfile
        ? Paths.registrazione.profiliPrivati
        : Paths.registrazione.profili;
      this.$http
        .get(path)
        .then(response => {
          const { code, values } = response.data;
          if (code == 200) {
            this.profiles = values;
          }
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.showLoading(false);
        });
    },
    pushAnalyticsEvent(success = null) {
      const userType = _.includes(
        GestioneProfili.PrivatiRegistazione,
        this.params.profile.selected.id,
      )
        ? 'privati'
        : 'aziende';
      this.pushToDataLayer('new_user_registration', {
        user_type: userType,
        education_program: this.params.programs.saceEducation.saceEduSigned ? 'yes' : 'no',
        business_program: this.params.programs.businessPromotion ? 'yes' : 'no',
        funnel_step: success || this.stepper.find(step => step.id === this.currentStep).name,
      });
    },
    submit(resp) {
      this.showLoading(true);
      this.params[resp.step] = resp.params;
      const submitParams = this.mapParams(this.params);
      this.$http
        .post(Paths.registrazione.submit, submitParams)
        .then(response => {
          const { code, message, erroreGenerico } = response.data;
          if (code != 200) {
            this.error = {
              hasError: true,
              msg: message || erroreGenerico,
              code,
            };
          } else {
            this.pushAnalyticsEvent('Registrazione avvenuta con successo');
            this.successMsg = message;
          }
        })
        .catch(e => {
          console.error(e);
          this.error.hasError = true;
        })
        .finally(() => {
          this.showLoading(false);
          this.currentStep = this.currentStep += 1;
        });
    },
    submitComplete(resp) {
      this.showLoading(true);
      this.params[resp.step] = resp.params;
      const submitParams = this.mapCompleteParams(this.params);
      this.$http
        .post(Paths.registrazione.submitComplete, submitParams)
        .then(response => {
          const { code, message, erroreGenerico } = response.data;
          if (code != 200) {
            this.error.hasError = true;
            this.error.msg = message || erroreGenerico;
          } else {
            this.pushAnalyticsEvent('Registrazione avvenuta con successo');
            this.successMsg = message;
          }
        })
        .catch(e => {
          console.error(e);
          this.error.hasError = true;
        })
        .finally(() => {
          this.showLoading(false);
          this.currentStep = this.currentStep += 1;
        });
    },
    showLoading(show) {
      this.$parent.showLoading(show);
    },
    mapParams(p) {
      return {
        fromPage: this.fromPage,
        recaptchaToken: p.privacy.recaptchaToken,
        contactViewRiskFree: {
          provenienza: this.provenienza,
          parameterURLp: this.parameterUrlp,
          parameterURLc: this.parameterUrlc,
          referralURL: window.location.href,

          profilo: {
            id: p.profile.selected.id,
            label: p.profile.selected.label,
          },
          nome: p.personal.name,
          cognome: p.personal.surname,
          ruolo: p.personal.role,
          telefono: p.personal.phone,
          descProfiloAltro: p.profile.customLabel,
          codiceFiscale: p.company.fiscalCode,
          codiceMichelangelo: p.company.michelangeloCode,
          saceEducation: p.programs.saceEducation,
          email: p.credential.email,
          emailconfirm: p.credential.email2,
          password: p.credential.password,
          confermaPassword: p.credential.password2,
          consensoCommerciale: p.privacy.commerciale,
          consensoGruppo: p.privacy.gruppo,
          businessPromotion: {
            bpSigned: p.programs.businessPromotion,
            contattiDilazioneId: [99],
            contattiExportAreaId: [99],
            contattiSettoreVenditaId: [99],
            contattiModalitaPagamentoId: [99],
          },
          ragioneSociale: p.company.companyName,
          idPaese: p.company.paeseAzienda,
        },
      };
    },
    mapCompleteParams(p) {
      return {
        fromPage: this.fromPage,
        contactViewRiskFree: {
          provenienza: this.provenienza,
          parameterURLp: this.parameterUrlp,
          parameterURLc: this.parameterUrlc,
          referralURL: window.location.href,
          profilo: {
            id: p.profile.selected.id,
            label: p.profile.selected.label,
          },
          nome: p.personal.name,
          cognome: p.personal.surname,
          ruolo: p.personal.role,
          telefono: p.personal.phone,
          descProfiloAltro: p.profile.customLabel,
          codiceFiscale: p.company.fiscalCode,
          codiceMichelangelo: p.company.michelangeloCode,
          saceEducation: p.programs.saceEducation,
          consensoCommerciale: p.privacy.commerciale,
          consensoGruppo: p.privacy.gruppo,
          businessPromotion: {
            bpSigned: p.programs.businessPromotion,
            contattiDilazioneId: [99],
            contattiExportAreaId: [99],
            contattiSettoreVenditaId: [99],
            contattiModalitaPagamentoId: [99],
          },
          ragioneSociale: p.company.companyName,
          idPaese: p.company.paeseAzienda,
        },
      };
    },
  },
};
</script>
